import { Component } from "react"

/* REST API */
import { currency, removeCurrency as remove, createCurrency as create, editCurrency as edit } from "../../api/Table"

/* Widgets */
import Layout from "./Layout"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* Helpers */
import { utils } from "../../helpers"

/* Sweet alert */
import Swal from "sweetalert2"




/* Widget Currency */
class Currency extends Component {

    constructor() {
        super()

        this.state = {
            status: "loading",
            data: [],
            currencies: [],
        }
    }

    componentDidMount = () => {
        this.load()
    }

    /* Load Dealers Data */
    load = (reload = false) => {

        /* Fields */
        const { uid } = this.props

        /* Check Params */
        if (!uid) {
            this.setState({ status: "error", data: [] })
            return
        }

        /* Refresh the page if necessary */
        if (reload) {
            this.setState({ status: "loading" })
        }

        /* START REST API */
        currency({ uid }).then((response) => {
            if (response.status) {
                this.setState({ status: "ok", data: response.data.list, currencies: response.data.currencies })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: [] })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: [] })
            }
            else {
                this.setState({ status: "error", data: [] })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [] })
        })

    }


    /* Remove Action */
    remove = (id) => {

        /* Fields */
        const { uid } = this.props
        const { data } = this.state

        /* Check Params */
        if (!uid) {
            Swal.fire(utils.notification(t("widget.unknownError"), "error"))
            return
        }

        Swal.fire({
            title: t("swal.deleteConfirm"),
            text: t("swal.deleteWarning"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#f44336",
            reverseButtons: true,
            confirmButtonText: t("swal.deleteButton"),
            cancelButtonText: t("swal.cancelButton"),
        }).then((result) => {
            if (result.isConfirmed) {

                remove({ uid, id }).then((response) => {
                    if (response.status === 200) {
                        const index = data.findIndex((e) => parseInt(e.id) === parseInt(id))

                        if (index > -1) {
                            const newData = data
                            newData.splice(index, 1)
                            this.setState({ data: newData })
                        }

                        Swal.fire(utils.notification(t("currency.deletedSuccess"), "success"))
                    }
                    else if (response.status === 401 || response.status === 403) {
                        Swal.fire(utils.notification(t("swal.noAccess"), "error"))
                    }
                    else if (response.status === 498) {
                        Swal.fire(utils.notification(t("swal.invalidKey"), "error"))
                    }
                    else {
                        Swal.fire(utils.notification(t("swal.generic"), "error"))
                    }
                }).catch(() => {
                    Swal.fire(utils.notification(t("swal.generic"), "error"))
                })
            }
        })

    }


    /* Create Action */
    create = async () => {

        /* Fields */
        const { uid, blackjack } = this.props
        const { data, currencies } = this.state

        /* Check Params */
        if (!uid) {
            Swal.fire(utils.notification(t("widget.unknownError"), "error"))
            return
        }

        const { value } = await Swal.fire({
            title: t("currency.addTitle"),
            html:
                `   
                    <div class="swal-form">
                        <select id="currency_create">
                            <option value="0" selected disabled>${t("currency.selectCurrency")}</option>
                            ${currencies.map((item) => `<option value="${item.id}">${item.name}</option>`)}
                        </select>
                        <input type="number" id="max_create" class="swal-select" placeholder="${t("currency.maxBet")}">
                        <input type="number" id="max_bonus_create" class="swal-select" placeholder="${t("currency.maxBonusBet")}">
                        <input type="number" id="min_create" class="swal-input" placeholder="${t("currency.minBet")}">
                        <input type="number" id="maxPay_create" class="swal-input" placeholder="${t("currency.maxPay")}">
                        <input type="text" id="chips_create" class="swal-input" placeholder="${t("currency.chips")}">
                        <input type="number" id="max_pp_create" class="swal-select" placeholder="${t("currency.maxPP")}">
                        <input type="number" id="max_to_create" class="swal-select" placeholder="${t("currency.max21")}">
                        <input type="number" id="max_b_create" class="swal-select" placeholder="${t("currency.maxBust")}">
                        <input type="number" id="max_cs_create" class="swal-select" placeholder="${t("currency.maxCS")}">
                    </div>
                `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonColor: "#2196f3",
            reverseButtons: true,
            cancelButtonText: t("swal.cancelButton"),
            confirmButtonText: t("currency.add"),
            preConfirm: () => {

                const currencyID = document.getElementById("currency_create").value
                const max = document.getElementById("max_create").value
                const maxPerfectPair = document.getElementById("max_pp_create").value
                const maxTwentyOne = document.getElementById("max_to_create").value
                const maxBust = document.getElementById("max_b_create").value
                const maxCrazySeven = document.getElementById("max_cs_create").value
                const maxBonus = document.getElementById("max_bonus_create").value
                const min = document.getElementById("min_create").value
                const maxPay = document.getElementById("maxPay_create").value
                const chips = document.getElementById("chips_create").value

                if (parseInt(currencyID) === 0) {
                    Swal.showValidationMessage(t("currency.enterCurrency"))
                    return false
                }
                if (max === "" || max === undefined || max === null) {
                    Swal.showValidationMessage(t("currency.enterMaxBet"))
                    return false
                }

                if (blackjack && (maxPerfectPair === "" || maxPerfectPair === undefined || maxPerfectPair === null)) {
                    Swal.showValidationMessage(t("currency.enterMaxPP"))
                    return false
                }

                if (blackjack && (maxTwentyOne === "" || maxTwentyOne === undefined || maxTwentyOne === null)) {
                    Swal.showValidationMessage(t("currency.enterMax21"))
                    return false
                }

                if (blackjack && (maxBust === "" || maxBust === undefined || maxBust === null)) {
                    Swal.showValidationMessage(t("currency.enterMaxBust"))
                    return false
                }

                if (blackjack && (maxCrazySeven === "" || maxCrazySeven === undefined || maxCrazySeven === null)) {
                    Swal.showValidationMessage(t("currency.enterMaxCS"))
                    return false
                }

                if (min === "" || min === undefined || min === null) {
                    Swal.showValidationMessage(t("currency.enterMinBet"))
                    return false
                }
                if (!blackjack && (maxPay === "" || maxPay === undefined || maxPay === null)) {
                    Swal.showValidationMessage(t("currency.enterMaxPay"))
                    return false
                }
                if (chips === "" || chips === undefined || chips === null) {
                    Swal.showValidationMessage(t("currency.enterChips"))
                    return false
                }

                return { currencyID, max, maxPerfectPair, maxTwentyOne, maxBust, maxCrazySeven, maxBonus, min, maxPay, chips }
            },
        })

        if (value) {
            create({ uid, ...value }).then((response) => {
                if (response.status === 200) {
                    data.push(response.data)
                    this.setState({ data })
                    Swal.fire(utils.notification(t("currency.addedSuccess"), "success"))
                }
                else if (response.status === 201) {
                    Swal.fire(utils.notification(t("currency.alreadyAdded"), "error"))
                }
                else if (response.status === 401 || response.status === 403) {
                    Swal.fire(utils.notification(t("swal.noAccess"), "error"))
                }
                else if (response.status === 498) {
                    Swal.fire(utils.notification(t("swal.invalidKey"), "error"))
                }
                else {
                    Swal.fire(utils.notification(t("swal.generic"), "error"))
                }
            }).catch(() => {
                Swal.fire(utils.notification(t("swal.generic"), "error"))
            })
        }
    }





    /* Edit Action */
    edit = async (currency) => {

        /* Fields */
        const { uid, blackjack } = this.props
        const { data } = this.state

        /* Check Params */
        if (!uid) {
            Swal.fire(utils.notification(t("widget.unknownError"), "error"))
            return
        }

        const { value } = await Swal.fire({
            title: `${t("currency.editTitle")} (${currency.name})`,
            html:
                `   
                    <div class="swal-form">
                        <input value="${currency.max}" type="number" id="max_edit" class="swal-select" placeholder="${t("currency.maxBet")}">
                        <input value="${currency.min}" type="number" id="min_edit" class="swal-input" placeholder="${t("currency.minBet")}">
                        <input value="${currency.maxBonus}" type="number" id="max_bonus_edit" class="swal-select" placeholder="${t("currency.maxBonusBet")}">
                        <input value="${currency.maxPay}" type="number" id="maxPay_edit" class="swal-input" placeholder="${t("currency.maxPay")}">
                        <input value="${currency.chips}" type="text" id="chips_edit" class="swal-input" placeholder="${t("currency.chips")}">
                        <input value="${currency.maxPerfectPair}" type="number" id="max_pp_edit" class="swal-select" placeholder="${t("currency.maxPP")}">
                        <input value="${currency.maxTwentyOne}" type="number" id="max_to_edit" class="swal-select" placeholder="${t("currency.max21")}">
                        <input value="${currency.maxBust}" type="number" id="max_b_edit" class="swal-select" placeholder="${t("currency.maxBust")}">
                        <input value="${currency.maxCrazySeven}" type="number" id="max_cs_edit" class="swal-select" placeholder="${t("currency.maxCS")}">
                    </div>
                `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonColor: "#2196f3",
            reverseButtons: true,
            cancelButtonText: t("swal.cancelButton"),
            confirmButtonText: t("common.save"),
            preConfirm: () => {

                const max = document.getElementById("max_edit").value
                const maxPerfectPair = document.getElementById("max_pp_edit").value
                const maxTwentyOne = document.getElementById("max_to_edit").value
                const maxBust = document.getElementById("max_b_edit").value
                const maxCrazySeven = document.getElementById("max_cs_edit").value
                const maxBonus = document.getElementById("max_bonus_edit").value
                const min = document.getElementById("min_edit").value
                const maxPay = document.getElementById("maxPay_edit").value
                const chips = document.getElementById("chips_edit").value

                if (max === "" || max === undefined || max === null) {
                    Swal.showValidationMessage(t("currency.enterMaxBet"))
                    return false
                }
                if (blackjack && (maxPerfectPair === "" || maxPerfectPair === undefined || maxPerfectPair === null)) {
                    Swal.showValidationMessage(t("currency.enterMaxPP"))
                    return false
                }

                if (blackjack && (maxTwentyOne === "" || maxTwentyOne === undefined || maxTwentyOne === null)) {
                    Swal.showValidationMessage(t("currency.enterMax21"))
                    return false
                }

                if (blackjack && (maxBust === "" || maxBust === undefined || maxBust === null)) {
                    Swal.showValidationMessage(t("currency.enterMaxBust"))
                    return false
                }

                if (blackjack && (maxCrazySeven === "" || maxCrazySeven === undefined || maxCrazySeven === null)) {
                    Swal.showValidationMessage(t("currency.enterMaxCS"))
                    return false
                }

                if (min === "" || min === undefined || min === null) {
                    Swal.showValidationMessage(t("currency.enterMinBet"))
                    return false
                }
                if (!blackjack && (maxPay === "" || maxPay === undefined || maxPay === null)) {
                    Swal.showValidationMessage(t("currency.enterMaxPay"))
                    return false
                }
                if (chips === "" || chips === undefined || chips === null) {
                    Swal.showValidationMessage(t("currency.enterChips"))
                    return false
                }

                return { max, maxPerfectPair, maxTwentyOne, maxBust, maxCrazySeven, maxBonus, min, maxPay, chips }
            },
        })

        if (value) {
            edit({ uid, id: currency.id, ...value }).then((response) => {
                if (response.status === 200) {

                    const index = data.findIndex((e) => parseInt(e.id) === parseInt(currency.id))

                    if (index > -1) {
                        const newData = data

                        newData[index].max = value.max
                        newData[index].maxPerfectPair = value.maxPerfectPair
                        newData[index].maxTwentyOne = value.maxTwentyOne
                        newData[index].maxBust = value.maxBust
                        newData[index].maxCrazySeven = value.maxCrazySeven
                        newData[index].maxBonus = value.maxBonus
                        newData[index].min = value.min
                        newData[index].maxPay = value.maxPay
                        newData[index].chips = value.chips

                        this.setState({ data: newData })
                    }

                    Swal.fire(utils.notification(t("currency.addedSuccess"), "success"))
                }
                else if (response.status === 401 || response.status === 403) {
                    Swal.fire(utils.notification(t("swal.noAccess"), "error"))
                }
                else if (response.status === 498) {
                    Swal.fire(utils.notification(t("swal.invalidKey"), "error"))
                }
                else {
                    Swal.fire(utils.notification(t("swal.generic"), "error"))
                }
            }).catch(() => {
                Swal.fire(utils.notification(t("swal.generic"), "error"))
            })
        }
    }


    render = () => {

        const { status, data } = this.state

        if (status !== "ok") {
            return <Layout status={status} reload={() => this.load(true)} />
        }

        return (
            <div className="table--modal-content">
                {data.map((item, index) =>
                    <div className="table--currency-item" key={`${index}`}>

                        <div className="table--currency-item-head">

                            <div className="table--currency-item-text">
                                <p>{item.name}</p>
                                <span>{item.code}</span>
                            </div>

                            <div className="table--currency-item-buttons">
                                <div onClick={() => this.edit(item)} className="table--currency-edit-button">
                                    <img src="/images/pencil.png" alt="Pencil" />
                                </div>
                                <div onClick={() => this.remove(item.id)} className="table--currency-remove-button">
                                    <img src="/images/trash.png" alt="Trash" />
                                </div>
                            </div>

                        </div>

                        <div className="table--currency-element">
                            <p>{t("currency.maxBetShort")}</p>
                            <span>{utils.convertor(item.max, item.symbol, item.isAfter)}</span>
                        </div>

                        <div className="table--currency-element">
                            <p>{t("currency.minBetShort")}</p>
                            <span>{utils.convertor(item.min, item.symbol, item.isAfter)}</span>
                        </div>

                        <div className="table--currency-element">
                            <p>{t("currency.maxPayShort")}</p>
                            <span>{utils.convertor(item.maxPay, item.symbol, item.isAfter)}</span>
                        </div>

                        <div className="table--currency-element">
                            <p>{t("currency.chipsLabel")}</p>
                            <span>{item.chips}</span>
                        </div>

                        <div className="table--currency-element">
                            <p>{t("currency.maxPP")}</p>
                            <span>{utils.convertor(item.maxPerfectPair, item.symbol, item.isAfter)}</span>
                        </div>
                        <div className="table--currency-element">
                            <p>{t("currency.max21")}</p>
                            <span>{utils.convertor(item.maxTwentyOne, item.symbol, item.isAfter)}</span>
                        </div>

                    </div>
                )}


                <div onClick={() => this.create()} className="table--currency-create-button">{t("currency.create")}</div>

            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps)(Currency)